const getAttributeValue = (id: string) => {
  const element = document.getElementById(id) as HTMLInputElement;
  return element ? element.value : '';
};

const getStoredValue = (id: string) => {
  const value = window.localStorage.getItem(id) as string;
  return value || '';
};

export const getMobileAccessToken = () =>
  getAttributeValue('mobile-bridge-access-token') || getStoredValue('access-token');

export const getMobileIdToken = () => getAttributeValue('mobile-bridge-id-token') || getStoredValue('id-token');

export const getUserAgent = () => getAttributeValue('mobile-bridge-user-agent') || getStoredValue('user-agent');

export const getPlatform = () => getUserAgent().split(' ')[2];

export const isIOS = () => /iOS/i.test(getPlatform());

export const isAndroid = () => /android/i.test(getPlatform());
